export default {
  'menu.home': '首页',
  'menu.chiselDetail': '钎杆',
  'menu.otherParts': '其他部件',
  'menu.prodTech': '生产工艺',
  'menu.service': '服务',
  'menu.aboutUs': '关于我们',
  'menu.exhibitionDetail': '展会详情'
}
